import { render, staticRenderFns } from "./VirtualGiftsSlider.vue?vue&type=template&id=25c7554a&scoped=true&"
import script from "./VirtualGiftsSlider.vue?vue&type=script&lang=js&"
export * from "./VirtualGiftsSlider.vue?vue&type=script&lang=js&"
import style0 from "./VirtualGiftsSlider.vue?vue&type=style&index=0&id=25c7554a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7554a",
  null
  
)

export default component.exports